
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './homeh9hud.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Phomeh9hud = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id690d081c8e5aed52dc841357" >

      <div id="ii5j" className="">
      
      <div id="i2wm" className="">
      
      <div id="i3to" className="">
      
      <div id="i4zac" className="">
      
      <div id="iepz9y" className="">
      
      <div id="iq3oci" className="">
      
        <a
          target="_blank"
          className="redes-sociales "
          id="iyoins"
          href="https://www.facebook.com/share/1MZa4kJbWJ/"
        >
          
      <img
        className=""
        id="iqxn7c"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx0u9w.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="iup45h"
          href="https://x.com/chambahonduras?t=paP02Yu8E246utuee6OmXA&s=09"
        >
          
      <img
        className=""
        id="iyzeef"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2duv.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="if3occ"
          href="https://www.instagram.com/chamba.hn?igsh=MWdzNTRtZDRqOXN3MQ=="
        >
          
      <img
        className=""
        id="i3pbhl"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2wo7.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="irgcil"
          href="https://www.youtube.com/@ChambaHonduras"
        >
          
      <img
        className=""
        id="iro1nx"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx35nw.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="ie3nzk" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="istkj" className="">
      
      <div id="ivpj2" className="">
      
        <LoftyDropdownComponent
          id="iy2a2e"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="ibj0c7" className="gjs-dropdown-menu-trigger link-navegacion ">
<>Ecosistema chamba
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="ixiofk" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className="link-navegacion "
          id="i0llh"
          href="/index"
        >
          
    <div id="ij1vq" className="">
    <>Chamba Index</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="inc25p"
          href="/chambanomics"
        >
          
    <div id="iszsx6" className="">
    <>Chambanomics</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="ir4m1m"
          href="/chambometro"
        >
          
    <div id="inisp" className="">
    <>Chambómetro Electoral</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="i68lj"
          href="/chambometro"
        >
          
        <a
          target=""
          className="link-navegacion "
          id="iog9i6"
          href="/talks"
        >
          
    <div id="iogkoj" className="">
    <>Chamba talks</>
    </div>
    
        </a>
        
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="ievl0d"
          href="/chambeador"
        >
          
    <div id="i40bdb" className="">
    <>Chambeador del año</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <a
          target=""
          className="link-navegacion "
          id="ilnkvn"
          href="/fundacion"
        >
          
    <div id="iv451u" className="">
    <>Fundación</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <div id="iaa1w" className="">
      
        <a
          target=""
          className=""
          id="itud73"
          href="/"
        >
          
      <img
        className=""
        id="ilkbh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx82cj.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="i4z2t" className="">
      
        <a
          target=""
          className="link-navegacion "
          id="ixf4dl"
          href="/sobrenosotros"
        >
          
    <div id="ijolgi" className="">
    <>Sobre Nosotros</>
    </div>
    
        </a>
        
        <a
          target="_blank"
          className="link-navegacion "
          id="ie2h9r"
          href="https://cne.chamba.hn/"
        >
          
    <div id="ialyo5" className="">
    <>Centro electoral</>
    </div>
    
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i23lgf" className="">
      
      <img
        className=""
        id="iaxk7b"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx82cj.png"
        alt="undefined"
      />
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre Nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/index"
        type=""
      >
        <>Chamba Index</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/index"
        type=""
      >
        <>Chambanomics</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/talks"
        type=""
      >
        <>Chamba Talks</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/fundacion"
        type=""
      >
        <>Fundación</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/chambometro"
        type=""
      >
        <>Chambómetro</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/chambeador"
        type=""
      >
        <>Chambeador del año</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div
        id="isa7id"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div id="i9x2g" className="">
      
      <div id="i1z0mi" className="">
      
      <div className="" id="im8zk">
        <>Sin democracia no hay CHAMBA</>
      </div>
      
      <div id="imq90l" className="">
      
        <a
          target=""
          className=""
          id="iip5w8"
          href="https://cne.chamba.hn/"
        >
          
      <span className="" id="i5l8fc">
        <>Revisa tu centro de votación</>
      </span>
      
        </a>
        
        <a
          target=""
          className=""
          id="i79vgj"
          href={`/contacto`}
        >
          
      <span className="" id="">
        <>Únirte a la comunidad</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i8g6" className="">
      
      <img
        className=""
        id="izriq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnxjnni.png"
        alt="undefined"
      />
      
      <div
        id="i9enf4"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="i7inz" className="">
      
      <div className="" id="izquz">
        <>¿En qué creemos?</>
      </div>
      
      <div className="" id="ijluj">
        <>En CHAMBA creemos que el verdadero cambio comienza cuando las personas tienen oportunidades reales. No hablamos de discursos, hablamos de empleo, educación responsabilidad fiscal, libre mercado y gobierno limitado. Nuestro propósito es conectar a los hondureños que quieren salir adelante con las herramientas, la información y las redes que pueden hacerlo posible.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div
        id="ide922"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="ilyx6r" className="">
      
      <div id="i9wsm7" className="">
      
      <div id="ihb2p" className="">
      
      <div id="ivm8j" className="item-text ">
      
      <div className="" id="if4lu">
        
      <b className="" id="ittgk">
        <>De un Chambeador a Otro</>
      </b>
      
      <br className="" id="" />
      <>Honduras realmente necesita chamba</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="ic1m1l"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div
        id="ib1cd8"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="i3b317" className="">
      
      <div className="" id="ink0s2">
        <>Proyectos y Programas</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="ivlcnl">
        <>Iniciativas que impulsan el cambio en Honduras</>
      </div>
      <>
        </>
      </div>
      
      <div
        id="iqta8m"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div
        id="iptdrj"
        className="tarjeta-programa "
        data-aos="fade-down"
        data-aos-duration="3000"
      >
      
        <a
          target=""
          className=""
          id="idb7a2"
          href={`/index`}
        >
          
      <div id="ivcsv7" className="">
      
      <img
        className="img-tarjeta-programa "
        id="i6llxm"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhq9riz4.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iy1f6u" className="">
      
      <div className="titulo-tarjeta-programa " id="ie4b8j">
        <>Chamba Index</>
      </div>
      
      <div className="descripcion-tarjeta-programa " id="ifoa7j">
        <>Investigación socioeconómica</>
      </div>
      <>
        </>
      </div>
      <>
        </>
        </a>
        
      </div>
      
      <div
        id="igrft3"
        className="tarjeta-programa "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
        <a
          target=""
          className=""
          id="ibwjqi"
          href={`/talks`}
        >
          
      <div id="iqblng" className="">
      
      <img
        className="img-tarjeta-programa "
        id="id24nj"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhqa41ki.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="igae78" className="">
      
      <div className="titulo-tarjeta-programa " id="isehhf">
        <>Chamba Talks</>
      </div>
      
      <div className="descripcion-tarjeta-programa " id="iaodri">
        <>Eventos de debate y pensamiento crítico</>
      </div>
      <>
        </>
      </div>
      <>
        </>
        </a>
        
      </div>
      
      <div
        id="isl4ma"
        className="tarjeta-programa "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
        <a
          target=""
          className=""
          id="ieawm7"
          href={`/chambeador`}
        >
          
      <div id="ivtxjk" className="">
      
      <img
        className="img-tarjeta-programa "
        id="icyack"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhqa5tjy.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i4mwl1" className="">
      
      <div className="titulo-tarjeta-programa " id="i9fa25">
        <>Chambeador del año</>
      </div>
      
      <div className="descripcion-tarjeta-programa " id="iq738b">
        <>Celebramos el esfuerzo que mueve al país</>
      </div>
      <>
        </>
      </div>
      <>
        </>
        </a>
        
      </div>
      
      <div
        id="ir5e0x"
        className="tarjeta-programa "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
        <a
          target=""
          className=""
          id="iqixl2"
          href={`/chambanomics`}
        >
          
      <div id="i3s1bi" className="">
      
      <img
        className="img-tarjeta-programa "
        id="i5p53l"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhr2sabr.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i2rsfy" className="">
      
      <div className="titulo-tarjeta-programa " id="iy278x">
        <>Chambanomics</>
      </div>
      
      <div className="descripcion-tarjeta-programa " id="i40i9z">
        <>Evaluación de políticas que generan empleo, crecimiento y oportunidades para Honduras.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
        </a>
        
      </div>
      
      <div
        id="i3h0ef"
        className="tarjeta-programa "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
        <a
          target=""
          className=""
          id="ipvovf"
          href={`/chambometro`}
        >
          
      <div id="i5g2iw" className="">
      
      <img
        className="img-tarjeta-programa "
        id="ixafek"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhr2j8lj.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iaop4l" className="">
      
      <div className="titulo-tarjeta-programa " id="is20dg">
        <>Chambómetro Electoral</>
      </div>
      
      <div className="descripcion-tarjeta-programa " id="ic1btj">
        <>Mide el clima político, económico y social mes a mes</>
      </div>
      <>
        </>
      </div>
      <>
        </>
        </a>
        
      </div>
      
      <div
        id="ijgroi"
        className="tarjeta-programa "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
        <a
          target=""
          className=""
          id="i6e04f"
          href={`/fundacion`}
        >
          
      <div id="i28x7q" className="">
      
      <img
        className="img-tarjeta-programa "
        id="i8orti"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhqa4w67.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i9ewfi" className="">
      
      <div className="titulo-tarjeta-programa " id="iunkh5">
        <>Fundación Chamba</>
      </div>
      
      <div className="descripcion-tarjeta-programa " id="im7ece">
        <>Impacto social y programas de apoyo</>
      </div>
      <>
        </>
      </div>
      <>
        </>
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <img
        className=""
        id="i68z7"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnxlys4.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i6yyhl" className="">
      
      <div
        id="ih6eoa"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div className="" id="iw3bdm">
        <>CAMBIANDO UNA GENERACIÓN</>
      </div>
      
      <div className="" id="iydme9">
        <>Creemos que los hondureños somos más fuertes cuando trabajamos juntos. Únete a nuestra plataforma ciudadana que promueve el empleo y la libertad.</>
      </div>
      
      <div id="isg2x7" className="">
      
        <a
          target=""
          className="boton-principal "
          id="idam18"
          href="/contacto"
        >
          
      <span className="" id="i4irhj">
        <>Únete ahora</>
      </span>
      
        </a>
        <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div id="izwmsw" className="">
      
      <div
        id="ivto4h"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="iiyra" className="">
      
      <div id="i2shs" className="item-explicacion ">
      
      <div id="iea65i" className="">
      
      <div id="itp49c" className="item-text ">
      
      <div className="" id="ijcio2">
        
      <b className="" id="iwernl">
        <>¿Sos Universitario?</>
      </b>
      
      <br className="" id="" />
      <>Karla de 21 años ya se unió a CHAMBA.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i9xa2t" className="item-explicacion ">
      
      <div id="i6wsjo" className="">
      
      <div id="inrlbk" className="item-text ">
      
      <div className="" id="iglg0l">
        
      <b className="" id="i2civg">
        <>¿Ya Chambeás?</>
      <br className="" id="" />
      
      </b>
      <>"Ojalá que todos tuvieramos CHAMBA". Rodrigo de 25 años.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="im61zs" className="item-explicacion ">
      
      <div id="irjxzl" className="">
      
      <div id="irmgff" className="item-text ">
      
      <div className="" id="i48ykl">
        
      <b className="" id="ienvpk">
        <>¿Tienes tu propia Chamba?</>
      </b>
      
      <br className="" id="" />
      <>Pamela de 22 años quisiera una Honduras donde sea fácil emprender.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <img
        className=""
        id="izaouj"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhqa0t2u.png"
        alt="undefined"
      />
      
      <div id="iolfbt" className="">
      
      <div
        id="ictuze"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="i4336w" className="">
      
      <img
        className=""
        id="isqkmf"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhrsmpo4.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ixgiwx" className="">
      
      <div className="" id="i7uyw5">
        <>Muy Pronto: Donaciones</>
      </div>
      
      <div className="" id="i6d0hh">
        <>Esta es una iniciativa independiente con el interés de crear CHAMBA educar y capacitar a los jóvenes, promover el emprendimiento sostenible y valor la libertad mediante personas, organizaciones, empresas e inversionistas que comparten nuestras misión y valores. Si quieres apoyar nuestra causa, ponte en contacto con nosotros</>
      </div>
      <>
        </>
      </div>
      
      <div id="i9ppjr" className="">
      
      <div className="" id="ierqzl">
        <>Disponible muy pronto</>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <video
        id="ie9h0h"
        className=""
        src="https://assetsprojects.s3.amazonaws.com/404pziimhr1nqq0.mp4"
        loop={true}
        autoPlay={true}
        controls={false}
        muted={true}
        playsInline={true}
      />
      
      <div id="i0mddi" className="">
      
      <div
        id="igqvfh"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="izppnm" className="">
      
      <div id="ivlnbc" className="">
      
      <div id="i3i76c" className="">
      
      <img
        className=""
        id="i5h34v"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhrzj09j.png"
        alt="undefined"
      />
      
      <div className="" id="imjm6s">
        <>SOCIAL MEDIA</>
      </div>
      <>
        </>
      </div>
      
      <div className="" id="i0snly">
        <>Síguenos para contenido exclusivo</>
      </div>
      <>
        </>
      </div>
      
      <div id="ii0mf" className="">
      
        <a
          target="_blank"
          className="redes-sociales contenedor-redes "
          id="igd3x"
          href="https://www.facebook.com/share/1MZa4kJbWJ/"
        >
          
      <img
        className=""
        id="ivqnc"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx0u9w.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales contenedor-redes "
          id="i5j0k"
          href="https://x.com/chambahonduras?t=paP02Yu8E246utuee6OmXA&s=09"
        >
          
      <img
        className=""
        id="ibnrn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2duv.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales contenedor-redes "
          id="ir76u"
          href="https://www.instagram.com/chamba.hn?igsh=MWdzNTRtZDRqOXN3MQ=="
        >
          
      <img
        className=""
        id="imcck"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2wo7.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales contenedor-redes "
          id="izuti"
          href="https://www.youtube.com/@ChambaHonduras"
        >
          
      <img
        className=""
        id="iyz7f"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx35nw.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div id="im78" className="">
      
      <div id="imr134" className="">
      
      <div id="i3kmzi" className="">
      
      <img
        className=""
        id="ijd9oi"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx82cj.png"
        alt="undefined"
      />
      
      <div className="" id="i9lfjc">
        <>En CHAMBA creemos que el verdadero cambio comienza cuando las personas tienen oportunidades reales. No hablamos de discursos, hablamos de empleo, educación responsabilidad fiscal, libre mercado y gobierno limitado. Nuestro propósito es conectar a los hondureños que quieren salir adelante con las herramientas, la información y las redes que pueden hacerlo posible.</>
      </div>
      <>
        </>
      </div>
      
      <div id="igpnrp" className="">
      
      <div className="" id="iwmzhr">
        <>Siguenos</>
      </div>
      
      <div id="imq9bt" className="">
      
        <a
          target="_blank"
          className="redes-sociales "
          id="iz7r4s"
          href="https://www.facebook.com/share/1MZa4kJbWJ/"
        >
          
      <img
        className=""
        id="ivyw3u"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx0u9w.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="ixs1gn"
          href="https://x.com/chambahonduras?t=paP02Yu8E246utuee6OmXA&s=09"
        >
          
      <img
        className=""
        id="iajkom"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2duv.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="iyc7xl"
          href="https://www.instagram.com/chamba.hn?igsh=MWdzNTRtZDRqOXN3MQ=="
        >
          
      <img
        className=""
        id="ihz5js"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2wo7.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="iwozpn"
          href="https://www.youtube.com/@ChambaHonduras"
        >
          
      <img
        className=""
        id="ie6na6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx35nw.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div className="" id="id4zm3">
        <>© 2025 CHAMBA. Todos los derechos reservados.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Phomeh9hud);
  